import React from 'react';
import { FaCertificate, FaGraduationCap, FaLightbulb, FaGoogle } from 'react-icons/fa';



const pulseAnimation = {
  animation: 'pulse 2s infinite',
  color: '#0af',
  marginLeft: '8px',
  verticalAlign: 'middle',
};

export default function AboutMe() {
  return (
    <>
      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.7; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>

      <div
        style={{
          maxWidth: '700px',
          margin: '2rem auto',
          color: '#eee',
          fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
          lineHeight: '1.6',
        }}
      >
        <h1
          style={{
            fontSize: '2.8rem',
            marginBottom: '0.5rem',
            color: '#0af',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Vyaas Subramanian
          <FaLightbulb style={pulseAnimation} title="Innovator" />
        </h1>

        <section style={{ marginBottom: '2rem' }}>
          <h2
            style={{
              fontSize: '1.6rem',
              borderBottom: '2px solid #0af',
              paddingBottom: '0.3rem',
            }}
          >
            About
          </h2>
          <p>
            Passionate about Artificial Intelligence and Machine Learning, I have built AI-driven projects, including a multi-method Netflix recommendation system and a facial recognition-based attendance tracker. I specialize in Python, Scikit-learn, TensorFlow, and OpenCV, with hands-on experience in AI/ML model development and data analysis. Open to AI research roles, internships, and collaborations! Check out my Projects page and click for links to the Git Repos for each Project!
          </p>
        </section>

       <section style={{ marginBottom: '2rem' }}>
            <h2
                style={{
                fontSize: '1.6rem',
                borderBottom: '2px solid #58a6ff',
                paddingBottom: '0.3rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: '#ffffff',  // changed to white here
                }}
            >
                <FaGraduationCap /> Education
            </h2>

            <div
                className="education-card"
                style={{
                backgroundColor: '#161b22',
                padding: '1rem 1.5rem',
                borderRadius: '12px',
                marginTop: '1rem',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.4)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
            >
                <h3
                style={{
                    margin: '0 0 0.5rem',
                    color: '#c9d1d9',
                    fontSize: '1.25rem',
                }}
                >
                BS in Computer Science
                </h3>
                <p
                style={{
                    margin: '0 0 0.25rem',
                    fontStyle: 'italic',
                    color: '#8b949e',
                }}
                >
                Knox College &mdash; '26
                </p>

                <p style={{ marginTop: '1rem', marginBottom: '0.25rem', color: '#58a6ff', fontWeight: 600 }}>
                Relevant Coursework:
                </p>
                <ul
                style={{
                    marginTop: '0.5rem',
                    paddingLeft: '1.5rem',
                    lineHeight: '1.8',
                    columns: 2,
                    columnGap: '2rem',
                    listStyleType: 'square',
                    color: '#c9d1d9',
                }}
                >
                <li>Artificial Intelligence</li>
                <li>Data Mining & Statistical Computing</li>
                <li>Software Engineering</li>
                <li>Software Testing</li>
                <li>Systems Programming</li>
                <li>Algorithm Design & Analysis</li>
                <li>Applied Data Structures</li>
                <li>Programming Languages</li>
                <li>Intro to Computer Science</li>
                <li>Program Design & Methodology</li>
                <li>Introductory Statistics</li>
                <li>Applied Calculus</li>
                <li>Discrete Mathematics</li>
                <li>Intro to Linear Algebra</li>
                <li>Software Dev. & Professional Practice</li>
                </ul>
            </div>
        </section>




        <section style={{ marginBottom: '2rem' }}>
          <h2
            style={{
              fontSize: '1.6rem',
              borderBottom: '2px solid #0af',
              paddingBottom: '0.3rem',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <FaCertificate /> Certifications
          </h2>
          <ul style={{ listStyleType: 'none', paddingLeft: '0', marginTop: '0.5rem' }}>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '0.4rem' }}>
                <FaGoogle color="#DB4437" /> Google Data Analytics
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '0.4rem' }}>
                <FaGoogle color="#DB4437" /> Google Generative AI
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '0.4rem' }}>
                <FaCertificate color="#054ADA" /> IBM AI Engineering
                </li>

            <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaCertificate color="#0af" /> ZTM AI/ML & Python
            </li>
        </ul>

        </section>

        <section>
          <a
            href="/Vyaas_Resume.pdf"
            download
            style={{
              display: 'inline-block',
              backgroundColor: '#0af',
              color: '#111',
              padding: '0.8rem 1.5rem',
              borderRadius: '6px',
              textDecoration: 'none',
              fontWeight: '600',
              boxShadow: '0 4px 10px rgba(0, 170, 255, 0.5)',
              transition: 'background-color 0.3s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#0088cc')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#0af')}
          >
            Download Resume
          </a>
        </section>
      </div>
    </>
  );
}

